import { Layout } from "antd";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./layout.css";

const { Header, Content } = Layout;

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Layout>
      <Header className="top_navbar">
        <Navbar toggleSidebar={toggleSidebar} />
      </Header>
      <Layout className="main_body">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <Content className="body_content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
